import React from "react";
import PropTypes from "prop-types";
import { documentPropType } from "custom-prop-types";
import { Button } from "components/common/button";
import styles from "components/documents/set-viewed-display.scss";

export const SetViewedDisplay = ({
  onChangeViewedSetting,
  documents,
  selectedDocumentIds
}) => {
  const selectedDocuments = selectedDocumentIds.map(id => documents.find(document => document.id === id));
  const viewedArray = selectedDocuments.filter(doc => doc.viewed === true);
  switch (viewedArray.length) {
    case (selectedDocuments.length):
      return <Button link onClick={ () => { onChangeViewedSetting(false); } }>Mark as unviewed</Button>;
    case (0):
      return <Button link onClick={ () => { onChangeViewedSetting(true); } }>Mark as viewed</Button>;
    default:
      return (
        <div className={ styles["viewed-buttons"] }>
          <div className={ styles.button }>
            <Button link onClick={ () => { onChangeViewedSetting(true); } }>Mark as viewed</Button>
          </div>
          <div className={ styles.button }>
            <Button link onClick={ () => { onChangeViewedSetting(false); } }>Mark as unviewed</Button>
          </div>
        </div>
      );
  }
};

SetViewedDisplay.propTypes = {
  documents: PropTypes.arrayOf(documentPropType).isRequired,
  onChangeViewedSetting: PropTypes.func.isRequired,
  selectedDocumentIds: PropTypes.arrayOf(PropTypes.string).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/set-viewed-display.jsx